module.exports = __webpack_public_path__ + "img/solution-training.47fad5c0.jpg";